import { defineStore } from 'pinia'
import axios from 'axios'

/**
 * Pinia store состояния уведомлений.
 * Хранит количество непрочитанных и обеспечивает периодическое обновление + приём WebSocket-событий.
 */
export const useNotificationsStore = defineStore('notifications', {
  state: () => ({
    unreadCount: 0,
    loading: false,
    intervalId: null,
    /** Инкрементируется при каждом WebSocket-событии — для watch на страницах */
    incomingCounter: 0,
  }),

  actions: {
    /**
     * Получить количество непрочитанных уведомлений с сервера
     */
    async fetchUnreadCount() {
      this.loading = true
      try {
        const response = await axios.post('/api/notifications/unread-count')
        if (response.data.success) {
          this.unreadCount = response.data.count
        }
      } catch (error) {
        console.error('Ошибка получения количества непрочитанных уведомлений:', error)
      } finally {
        this.loading = false
      }
    },

    /**
     * Запустить периодическое обновление количества непрочитанных (каждую минуту)
     */
    startPolling() {
      this.fetchUnreadCount()
      this.stopPolling()
      this.intervalId = setInterval(() => {
        this.fetchUnreadCount()
      }, 60000)
    },

    /**
     * Остановить периодическое обновление
     */
    stopPolling() {
      if (this.intervalId) {
        clearInterval(this.intervalId)
        this.intervalId = null
      }
    },

    /**
     * Уменьшить счётчик на 1 (при прочтении одного уведомления)
     */
    decrementCount() {
      if (this.unreadCount > 0) {
        this.unreadCount--
      }
    },

    /**
     * Увеличить счётчик на 1 (при отметке уведомления как непрочитанного)
     */
    incrementCount() {
      this.unreadCount++
    },

    /**
     * Обработка входящего уведомления из WebSocket
     */
    handleIncomingNotification() {
      this.unreadCount++
      this.incomingCounter++
    },

    /**
     * Обнулить счётчик (при прочтении всех уведомлений)
     */
    resetCount() {
      this.unreadCount = 0
    },
  },

  getters: {
    hasUnread: (state) => state.unreadCount > 0,
  },
})
